module.exports = __webpack_public_path__ + "static/media/wavm8s-001-klahrk.10efa5b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-001-klahrk.mp3
// module id = SZjg
// module chunks = 0